import type { ReactNode } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CenterAccounts from './CenterAccounts'
import RoleManagement from './RoleManagement'

type Tab = 'accounts' | 'roles'

/** 센터 계정 관리 = 센터 계정 관리(기본) + 역할 관리 탭 셸. 내용은 기존 페이지 컴포넌트 그대로 렌더. */
export default function CenterAccountsSettings() {
  const { t } = useTranslation('nav')
  const [searchParams, setSearchParams] = useSearchParams()

  const tab: Tab = searchParams.get('tab') === 'roles' ? 'roles' : 'accounts'

  const selectTab = (next: Tab) => {
    setSearchParams(next === 'accounts' ? {} : { tab: next }, { replace: true })
  }

  return (
    <div>
      <div className="flex gap-2 mb-6 border-b">
        <TabButton active={tab === 'accounts'} onClick={() => selectTab('accounts')}>
          {t('adminMenu.centerAccounts')}
        </TabButton>
        <TabButton active={tab === 'roles'} onClick={() => selectTab('roles')}>
          {t('adminMenu.roleManagement')}
        </TabButton>
      </div>
      {tab === 'accounts' ? <CenterAccounts /> : <RoleManagement />}
    </div>
  )
}

function TabButton({ active, onClick, children }: { active: boolean; onClick: () => void; children: ReactNode }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-4 py-2 -mb-px text-sm font-medium ${active ? 'border-b-2 border-primary-600 text-primary-600' : 'text-gray-600 hover:text-gray-900'}`}
    >
      {children}
    </button>
  )
}
